msgid ""
msgstr ""
"POT-Creation-Date: 2024-02-16 14:52+0100\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. Suffix part of tab title which looks something like e.g. 'Selg med AI | FINN.no' (where this message is the equivalent of the ' | FINN.no' part, including the space at the beginning)
#. js-lingui-explicit-id
#: src/server/server.ts:225
msgid "page.title.suffix"
msgstr " | Brand"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:230
#: src/server/pages/default-landing.tsx:117
msgid "content.card2.title"
msgstr "... Post it easily with AI"

#. js-lingui-explicit-id
#: src/server/pages/images.ts:27
#: src/server/pages/images.ts:68
#: src/server/pages/images.ts:110
msgid "content.image.finn.intro2.alt"
msgstr "A hand holding a smartphone that displays a photo of a cream-colored knitted polo sweater against a pink background, with the actual sweater visible underneath the phone."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:318
#: src/server/pages/default-landing.tsx:234
msgid "content.steps.step3.description"
msgstr "AI suggests title and description. You just add price and address before you publish."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:291
#: src/server/pages/default-landing.tsx:207
msgid "content.steps.step1.description"
msgstr "Angle, lighting, quantity - AI gives you good advice when creating your ad!"

#. js-lingui-explicit-id
#: src/server/pages/images.ts:35
msgid "content.image.finn.intro3.alt"
msgstr "Close-up of a smartphone screen showing a notification from the FINN app stating that the money is on its way and may take 2 to 5 business days to appear in the user’s account, against a blurred warm-toned background."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:76
#: src/server/pages/images.ts:118
msgid "content.image.tori.intro3.alt"
msgstr "Close-up of a smartphone screen showing a Tori app notification stating that the money is on its way and will appear in the user’s account in approximately 2–5 business days, displayed over a warm, blurred background of lights."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:43
msgid "content.image.finn.aiHelper.alt"
msgstr "Close-up of a smartphone screen showing FINN's AI-assistant interface that autofills product details, including brand, type, size, and color, with text explaining that the user can adjust any incorrect information."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:84
#: src/server/pages/images.ts:126
msgid "content.image.tori.aiHelper.alt"
msgstr "Close-up of a smartphone screen showing Tori’s AI-assistant interface autofilling product details such as brand, type, and size, with text explaining that the user can adjust any incorrect information."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:19
#: src/server/pages/images.ts:60
#: src/server/pages/images.ts:102
msgid "content.image.finn.intro1.alt"
msgstr "Cream-colored knitted polo sweater with textured patterns, a ribbed collar, and two buttons, folded neatly on a pink background."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:313
#: src/server/pages/default-landing.tsx:229
msgid "content.steps.step3.title"
msgstr "Details are filled in automatically"

#. js-lingui-explicit-id
#: src/server/pages/default-landing.tsx:56
msgid "content.title"
msgstr "Do you have money in the attic?"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:208
#: src/server/pages/default-landing.tsx:95
msgid "content.card1.title"
msgstr "Find things you don't use..."

#. js-lingui-explicit-id
#: src/server/pages/images.ts:51
msgid "content.image.finn.testimonial.alt"
msgstr "Headshot of Vigdis"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:279
#: src/server/pages/default-landing.tsx:197
msgid "content.steps.title"
msgstr "How the AI helper works"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:299
#: src/server/pages/default-landing.tsx:215
msgid "content.steps.step2.title"
msgstr "Let AI find the right category"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:213
#: src/server/pages/default-landing.tsx:100
msgid "content.card1.description"
msgstr "Maybe a nice jacket or old iPad? Earn money while others get to enjoy it!"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:252
#: src/server/pages/default-landing.tsx:137
msgid "content.card3.title"
msgstr "Money straight in your pocket!"

#. js-lingui-explicit-id
#: src/server/pages/default-landing.tsx:59
msgid "content.description"
msgstr "Now is a great time to sell what you don't use! Create your ad in under 2 minutes with FINN's new AI tool."

#. js-lingui-explicit-id
#: src/islands/create-item-button/create-item-button.tsx:43
msgid "button.createItem"
msgstr "Post an ad"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:326
#: src/server/pages/default-landing.tsx:242
msgid "content.steps.step4.title"
msgstr "Publish"

#. Main part of tab title which looks something like e.g. 'Selg med AI | FINN.no' (where this message is the equivalent of the 'Selg med AI' part)
#. js-lingui-explicit-id
#: src/server/server.ts:218
msgid "page.title.main"
msgstr "Sell with AI"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:235
#: src/server/pages/default-landing.tsx:120
msgid "content.card2.description"
msgstr "Take a photo of the product you want to sell, and AI will help you with the title, description and category."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:286
#: src/server/pages/default-landing.tsx:202
msgid "content.steps.step1.title"
msgstr "Take the best possible photos"

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:304
#: src/server/pages/default-landing.tsx:220
msgid "content.steps.step2.description"
msgstr "The images are continuously analyzed and what you're selling is automatically placed in the right category on FINN."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:257
#: src/server/pages/default-landing.tsx:142
msgid "content.card3.description"
msgstr "The money goes securely straight to your account as soon as the buyer has paid safely via FINN."

#. js-lingui-explicit-id
#: src/server/pages/campaigns/finn-faebrik-samarbeid/finn-faebrik-samarbeid.tsx:329
#: src/server/pages/default-landing.tsx:245
msgid "content.steps.step4.description"
msgstr "This one you have to do yourself, of course!"
